export const COURSE_DURATION_REQUIRED_MESSAGE = 'Set the full time or the part time duration';

// A course runs full time, part time or both, so at least one of the durations must be set
export const hasCourseDuration = (fullTime?: number | null, partTime?: number | null) =>
  (fullTime ?? 0) > 0 || (partTime ?? 0) > 0;
